import operatorApiFetch from './apiService';

export const shippingRateCardsService = {
  fetchList: async () => {
    const response = await operatorApiFetch('shipping_rate_cards');
    if (!response.ok) throw new Error('Failed to fetch rate cards');
    return response.json();
  },

  fetchOne: async (id) => {
    const response = await operatorApiFetch(`shipping_rate_cards/${id}`);
    if (!response.ok) throw new Error('Failed to fetch rate card');
    return response.json();
  },

  create: async (data) => {
    const response = await operatorApiFetch('shipping_rate_cards', {
      method: 'POST',
      body: JSON.stringify({ shipping_rate_card: data })
    });
    if (!response.ok) throw new Error('Failed to create rate card');
    return response.json();
  },

  update: async (id, data) => {
    const response = await operatorApiFetch(`shipping_rate_cards/${id}`, {
      method: 'PUT',
      body: JSON.stringify({ shipping_rate_card: data })
    });
    if (!response.ok) throw new Error('Failed to update rate card');
    return response.json();
  },

  delete: async (id) => {
    const response = await operatorApiFetch(`shipping_rate_cards/${id}`, {
      method: 'DELETE'
    });
    if (!response.ok) throw new Error('Failed to delete rate card');
    return response.json();
  }
};
